var map = {
	"./en/common": 1807,
	"./en/common.json": 1807,
	"./en/seo": 63351,
	"./en/seo.json": 63351,
	"./en/unit": 3891,
	"./en/unit.json": 3891,
	"./nn-NO/common": 58512,
	"./nn-NO/common.json": 58512,
	"./nn-NO/seo": 64735,
	"./nn-NO/seo.json": 64735,
	"./nn-NO/unit": 32713,
	"./nn-NO/unit.json": 32713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4921;